import { documentSources, sourceLabel, type DocumentField, type TemplateMetadata } from "./permitDocuments";

// Exact aliases only: a similar spelling must never silently select another fact.
const markerSources: Record<string, string> = {
  ...Object.fromEntries(documentSources.filter(([source]) => source.startsWith("radnik.")).map(([source]) => [source.slice("radnik.".length), source])),
  ime_prezime: "radnik.full_name",
  worker: "radnik.full_name",
  birth_date: "radnik.datum_rodenja",
  adresa_boravista: "radnik.adresa_boraviste",
  prethodna_adresa: "manual.previous_address",
  adresa_iz_zahtjeva: "address.registration",
  datum_odjave: "radnik.datum_prestanka",
  datum_prijave: "radnik.datum_prijave_osiguranja",
  datum_izdavanja_dozvole: "dozvola.datum_izdavanja",
  datum_isteka_dozvole: "dozvola.datum_isteka",
  broj_dozvole: "dozvola.broj_dozvole",
  company: "firma.naziv",
  company_oib: "firma.oib",
  company_address: "firma.adresa",
  authority: "pu.name",
  authority_address: "pu.address",
  case_number: "predmet.case_number",
};

export function documentSourceSelection(source: string) {
  return { source, manual: /^(manual|address|family)\./.test(source), default_value: null };
}

export function suggestDocumentFields(markers: string[]): DocumentField[] {
  return [...new Set(markers)].filter(key => !/^(?:\{\{)?rod:/.test(key)).map(key => {
    const source = Object.hasOwn(markerSources, key) ? markerSources[key]! : "";
    return {
      key,
      label: source ? sourceLabel(source) : key.replaceAll("_", " "),
      section: "",
      required: true,
      ...documentSourceSelection(source),
    };
  });
}

export function newDocumentTemplate(filename: string): TemplateMetadata {
  const name = filename.replace(/\.docx$/i, "").replace(/[_-]+/g, " ").trim().slice(0, 200) || "Novi predložak";
  const slug = name.toLowerCase().replaceAll("đ", "d").normalize("NFD").replace(/\p{M}/gu, "").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  const prefix = /^[a-z]/.test(slug) ? slug : `predlozak_${slug}`;
  // A new upload must not become a version of an existing code, even when two
  // administrators independently choose the same filename.
  const code = `${prefix.slice(0, 47)}_${crypto.randomUUID().replaceAll("-", "")}`;
  return { code, name, authority_id: null, fields: [] };
}
